<template>
    <div class="manage--left menu-manual" ref="lesson-left">
        <div v-if="!mobile" class="div-list-lessons" :class="{ht: !mobile}">
            <el-collapse v-model="activeName" @change="toggleActive()">
                <template v-for="(item, index) in general">
                    <el-collapse-item :name="index" :key="index" class="lkt-collapse-item"  >
                        <span class="collapse-title" slot="title">{{item.menuName}}</span>
                        <template v-for="(item1, index1) in item.contentList">
                            <div class="nqt--list--lessons lkt-height-div" :class="[{active: item1.type == activeID}]" v-on:click="changeItem({type: item1.type, name: item1.name})" :key="index1">
                                <p class="title-lesson">
                                    <template v-if="item1.type==31
                                        || item1.type==32
                                        || item1.type==33
                                        || item1.type==34
                                        || item1.type==35
                                        || item1.type==36
                                        || item1.type==37
                                        || item1.type==38
                                        || item1.type==39
                                        || item1.type==40"
                                    >
                                        <b class="item_child">&nbsp;&nbsp;{{item1.name}}</b>
                                    </template>
                                    <template v-else>
                                        <b class="item_cha">{{item1.name}}</b>
                                    </template>
                                </p>
                            </div>
                        </template>
                    </el-collapse-item>
                </template>
            </el-collapse>
        </div>
        <div v-else class="div-list-lessons" :class="{ht: !mobile}">
            <el-collapse v-model="activeName" @change="toggleActive()">
                <template v-for="(item, index) in general">
                    <el-collapse-item :name="index" :key="index" class="lkt-collapse-item">
                        <span class="collapse-title" slot="title">{{item.menuName}}</span>
                        <template v-for="(item1, index1) in item.contentList">
                            <div v-if="item1.isMobile" class="nqt--list--lessons lkt-height-div" :class="[{active: item1.type == activeID}]" v-on:click="changeItem({type: item1.type, name: item1.name})" :key="index1">
                                <p class="title-lesson">
                                    <template v-if="item1.type==31
                                        || item1.type==32
                                        || item1.type==33
                                        || item1.type==34
                                        || item1.type==35
                                        || item1.type==36
                                        || item1.type==37
                                        || item1.type==38
                                        || item1.type==39
                                        || item1.type==40"
                                    >
                                        <b class="item_child">&nbsp;&nbsp;{{item1.name}}</b>
                                    </template>
                                    <template v-else>
                                        <b class="item_cha">{{item1.name}}</b>
                                    </template>
                                </p>
                            </div>
                        </template>
                    </el-collapse-item>
                </template>
            </el-collapse>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                keyword: "",
                result: [],
                type: 0,
                activeID: 0,
                general: [],
                activeName: [0],
            };
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        watch: {},
        async created() {
            this.general = this.data.dataGeneral;
        },
        methods: {
            changeItem: function (params) {
                this.activeID = params.type;
                this.$emit("changeItem", params);
                document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
            },
            toggleActive () {
                this.activeName = this.activeName.pop();
            }
        },
    };
</script>
<style scoped>
    .lkt-collapse-item {
        padding-bottom:0 !important;
    }
    .headerMenu {
        border-radius: unset !important;
        text-align: center;
    }
    .headerMenu:hover {
        background: none !important;
        cursor: none;
    }
    .headerMenu b {
        color: red !important;
        font-size: 12pt;
    }
    .collapse-title {
        font-size: 14pt;
        color: #000 !important;
        background: unset !important;
    }
    .el-collapse {
        border: none;
    }
    .lkt-height-div {
        height: 30px;
    }
    .lkt-icon-present-absent {
        width: 50px;
    }
    .inputDate {
        max-width: 129px !important;
    }
    .el-col-2 {
        margin-top: 5px;
        text-align: center;
    }
    .el-form-item {
        padding: 0px !important;
        margin-bottom: 0px !important;
    }
    .button--search--left {
        width: auto;
        /* height: auto; */
    }
    .nqt--list--lessons {
        cursor: pointer !important;
    }
    .div-list-lessons {
        cursor: pointer !important;
        overflow: auto;
        height: 675px;
    }
    .nqt-end {
        background: #1f1313;
        height: calc(100% - 10px);
        position: absolute;
        right: 5px;
        width: auto;
        top: 5px;
        color: #fff;
        padding: 7px;
        font-size: 10px;
        border-radius: 7px;
        display: flex;
    }
    .nqt--list--lessons:hover {
        background: #d7d7d7;
    }
    .isTeacher {
        color: #9b99a2;
    }
    .btn_download {
        background: transparent;
        border: none;
        border-radius: 5px;
        margin-left: 2px;
    }
    .btn_download:hover {
        background: #d7d7d7;
    }
    /* custom */
    .div-list-lessons {
        border: 1px solid #e3e3e3;
        padding: 5px;
        /* border-radius: 5px; */
        margin-top: unset;
        padding-bottom: 0;
    }
    .ht {
        /* height: calc(100% - 80px)!important; */
        height: 100% !important;
        padding-top: 0 !important;
    }
    .nqt--list--lessons {
        border-bottom: 1px solid #e3e3e3;
    }
    .nqt--list--lessons.active, .nqt--list--lessons b.item_cha {
        color: #0071c5;
    }
    .nqt--list--lessons.active,
    .nqt--list--lessons {
        color: #000;
        border-radius: 10px;
    }
    /* .nqt--list--lessons.active, .nqt--list--lessons b:hover {
        background: #0071c5;
        color: #fff !important;
        border-radius: 10px;
    } */
    .active {
        color: #fff !important;
    }
    .active b {
        color: #fff!important;
    }
    .active:hover {
        background: #0071c5;
    }
    .manage--left {
        box-shadow: none;
        padding-top: 0;
        padding-bottom: 0;
        border: none;
    }
    .search--type {
        display: flex;
        justify-content: center;
        height: 36px;
        margin-bottom: 5px;
    }
    .search--type--btn {
        border: 0;
        color: #e3e3e3;
        font-size: 12px;
        width: 50%;
        background: transparent;
        font-weight: 300;
    }
    .search--type--btn.active--nqt {
        color: #0071c5;
        border-bottom: 2px solid #0071c5;
    }
    @media (max-width: 480px) {
        .inputDate {
            width: calc(50% - 13px);
            max-width: 100% !important;
            -webkit-appearance: none;
            -moz-appearance: none;
        }
        .el-date-editor.el-input .el-input__inner {
            width: 154px !important;
        }
    }
    .nqt--list--lessons b.item_child {
        color: rgb(0 149 46);
    }
</style>


// WEBPACK FOOTER //
// src/components/manual/left_manual.vue